

    @if (!customizableMode) {
        <p-card>
        <div  class="padding15" style="position:relative;">
            <div class="module-flex-row-with-space">
                <div class="module-title">
                    <div class="module-title-label" >Automated Rebalances</div>
                    <div [routerLink]="['/reports/auto-rebalance-report']" style="cursor:pointer"><img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg"></div>
                </div>
                @if (singleWidth) {
                    <div class="module-auto-rebalances-selector">
                        <mat-button-toggle-group as-button-group variation="primary" [(ngModel)]="selectedSection" (ngModelChange)="applySectionChange()">
                            <mat-button-toggle value="portfolios" checked>Portfolios</mat-button-toggle>
                            <mat-button-toggle value="orders">Orders</mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                }
            </div>

            @if (!autoRebalancePortfolioData || !autoRebalanceOrderData) {
                <div class='loading-spinner'></div>
            }

            @if (autoRebalancePortfolioData && autoRebalanceOrderData) {

                @if (singleWidth) {
                    <div style="height: 214px;">
                    @if (showPortfolios) {
                        <div style="margin-top: 30px;">
                            <span class="module-auto-rebalances-panel-label">Portfolios:</span>
                            <span class="modules-panel-number">{{autoRebalancePortfolioData.totalAutoRebalPfCount + ((currentDate === nextDate && autoRebalancePortfolioData.totalScheduledAutoRebalPfCount > 0)
                                ? autoRebalancePortfolioData.totalScheduledAutoRebalPfCount: 0)}}</span>
                        </div>

                        <div style="margin-top: 20px;display: flex;flex-direction: row;">
                            <div style="width: 50%; border-right: 1px solid #CBD1D6;padding-right: 15px;">
                                <ng-container [ngTemplateOutlet]="modulePortfoliosTemplate"></ng-container>
                            </div>
                            <div style="width: 50%;padding-left: 15px;">
                                <ng-container [ngTemplateOutlet]="modulePortfoliosUpcomingTemplate"></ng-container>
                            </div>
                        </div>
                    }
                    @if (showOrders) {
                        <div style="margin-top: 30px;">
                            <span class="module-auto-rebalances-panel-label">Orders:</span>
                            <span class="modules-panel-number">{{autoRebalanceOrderData.totalCount || 0}}</span>
                        </div>
                        <div style="margin-top: 20px;">
                            <ng-container [ngTemplateOutlet]="moduleOrdersTemplate"></ng-container>
                        </div>
                    }
                    </div>
                }
                @if (!singleWidth) {
                    <div style="height: 227px;">
                    <div style="margin-top: 20px;display: flex;flex-direction: row;">
                        <div style="border-right: 1px solid #98A4AE;width: 66.66%;">
                            <div style="padding-bottom: 20px;font-size: 14px;">
                                <span style="padding-right: 5px;color: #4C5561;">Scheduled for today:</span>
                                <span class="modules-panel-number">{{currentDate}}</span>
                            </div>
                            <div style="display: flex;flex-direction: row;">
                                <div style="width: 50%; padding-right: 15px;border-right: 1px solid #CBD1D6;">
                                    <div style="padding-bottom: 10px;">
                                        <span class="module-auto-rebalances-panel-label">Portfolios:</span>
                                        <span class="modules-panel-number">{{autoRebalancePortfolioData.totalAutoRebalPfCount + ((currentDate === nextDate && autoRebalancePortfolioData.totalScheduledAutoRebalPfCount > 0)
                                            ? autoRebalancePortfolioData.totalScheduledAutoRebalPfCount: 0)}}</span>
                                    </div>
                                    <ng-container [ngTemplateOutlet]="modulePortfoliosTemplate"></ng-container>
                                </div>
                                <div style="width: 50%;padding:0 15px;">
                                    <div style="padding-bottom: 10px;">
                                        <span class="module-auto-rebalances-panel-label">Orders:</span>
                                        <span class="modules-panel-number">{{autoRebalanceOrderData.totalCount || 0}}</span>
                                    </div>
                                    <ng-container [ngTemplateOutlet]="moduleOrdersTemplate"></ng-container>
                                </div>
                            </div>

                        </div>

                        <div style="width: 33.33%;padding-left: 15px;padding-top: 35px;">
                            <ng-container [ngTemplateOutlet]="modulePortfoliosUpcomingTemplate"></ng-container>
                        </div>
                    </div>
                    </div>
                }


                <div class="widget-footer">
                    @if (globalSettings?.isTradingPaused) {
                        <div>Orders: <a (click)="showGlobalSettingsDialog();">Paused</a></div>
                    } @else {
                        <div>Order time: <a (click)="showGlobalSettingsDialog();">{{globalSettings?.tradeTime}}</a></div>
                    }
                    <div>
                        <div class="refreshIcon" (click)="refreshWidgetData()"></div>
                        <span class="timestamp">Updated {{timeFromTimestamp}}, {{dateFromTimestamp}}</span>
                    </div>
                </div>

                <ng-template #modulePortfoliosTemplate>
                    @if (singleWidth) {
                        <div style="padding-bottom: 10px;font-size: 14px;">
                            <span style="padding-right: 5px;color: #4C5561;">Rebalanced today:</span>
                            <span class="bold">{{currentDate}}</span>
                        </div>
                    }
                    @if ((!autoRebalancePortfolioData.totalAutoRebalPfCount
                        && (!autoRebalancePortfolioData.totalScheduledAutoRebalPfCount || currentDate !== nextDate || nullstate))) {
                        <div style="padding: 10px 0;line-height: 20px;">
                            There are no Automated Rebalances scheduled for today.
                        </div>
                    }
                    @if (autoRebalancePortfolioData.totalScheduledAutoRebalPfCount > 0 && currentDate === nextDate) {
                        <div class="module-flex-row-with-space" style="padding: 10px 0;">
                            <div style="font-size: 14px;color: #000;">
                                <span class="modules-panel-number" style="padding-right: 5px;">{{autoRebalancePortfolioData.totalScheduledAutoRebalPfCount | number}}</span>
                                <span>To be rebalanced</span>
                            </div>
                            <img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg" (click)="showAutoRebalPfScheduled()" >
                        </div>
                    }
                    @if (autoRebalancePortfolioData.autoRebalErrorCount > 0) {
                        <div class="module-flex-row-with-space" style="padding: 10px 0;border-bottom: 1px solid #CBD1D6;">
                            <div style="font-size: 14px;color: #000;">
                                <span class="modules-panel-number" style="padding-right: 5px;color: #C10B14;">{{autoRebalancePortfolioData.autoRebalErrorCount | number}}</span>
                                <span>Rebalance errors</span>
                            </div>
                            <img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg" (click)="showAutoRebalPfErrors()" >
                        </div>
                    }
                    @if (autoRebalancePortfolioData.autoRebalPfNoOrdersCount > 0) {
                        <div class="module-flex-row-with-space" style="padding: 10px 0;border-bottom: 1px solid #CBD1D6;">
                            <div style="font-size: 14px;color: #000;">
                                <span class="modules-panel-number" style="padding-right: 5px;">{{autoRebalancePortfolioData.autoRebalPfNoOrdersCount | number}}</span>
                                <span>Without orders</span>
                            </div>
                            <img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg" (click)="showAutoRebalPfNoOrders()" >
                        </div>
                    }
                    @if (autoRebalancePortfolioData.autoRebalPfOrdersCount > 0) {
                        <div class="module-flex-row-with-space" style="padding: 10px 0;">
                            <div style="font-size: 14px;color: #000;">
                                <span class="modules-panel-number" style="padding-right: 5px;">{{autoRebalancePortfolioData.autoRebalPfOrdersCount | number}}</span>
                                <span>With orders</span>
                            </div>
                            <img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg" (click)="showAutoRebalPfOrders()" >
                        </div>
                    }
                    <div style="height: 10px;"></div>
                </ng-template>

                <ng-template #modulePortfoliosUpcomingTemplate>
                    <div style="padding-bottom: 10px;font-size: 14px;">
                        <span style="padding-right: 5px;color: #4C5561;">Upcoming:</span>
                        <span style="font-weight: bold;">{{nextDate || ''}}</span>
                    </div>

                    @if ((autoRebalancePortfolioData.totalScheduledAutoRebalPfCount > 0) && currentDate !== nextDate && !nullstate) {
                        <div class="module-flex-row-with-space" style="padding: 10px 0;">
                            <div style="font-size: 14px;color: #000;">
                                <span class="modules-panel-number" style="padding-right: 5px;">{{autoRebalancePortfolioData.totalScheduledAutoRebalPfCount | number}}</span>
                                <span>To be rebalanced</span>
                            </div>
                            <img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg" (click)="showAutoRebalPfScheduled()" >
                        </div>
                    }
                    @if (currentDate === nextDate && autoRebalancePortfolioData.totalScheduledAutoRebalPfCount > 0) {
                        <div style="padding: 10px 0;">
                            <span style="color: #000;line-height: 20px;">Upcoming automated rebalances are being processed. Please try again later.</span>
                        </div>
                    }
                    @if (!autoRebalancePortfolioData.totalScheduledAutoRebalPfCount && nextDate && currentDate !== nextDate) {
                        <div style="padding: 10px 0;">
                            <span style="color: #000;line-height: 20px;">There are no automated rebalances scheduled for <span class="bold">{{nextDate}}</span>
                            </span>
                        </div>
                    }
                    @if ((!autoRebalancePortfolioData.totalScheduledAutoRebalPfCount && !nextDate) || nullstate) {
                        <div style="padding: 10px 0;">
                            <span style="color: #000;line-height: 20px;">There are no automated rebalances scheduled. You can configure them from <a (click)="goToPortfolios();" style="color: #006E99!important;">Portfolios</a></span>
                        </div>
                    }
                </ng-template>

                <ng-template #moduleOrdersTemplate>
                    @if (autoRebalanceOrderData.errorCount > 0) {
                        <div class="module-flex-row-with-space" style="padding: 10px 0;border-bottom: 1px solid #CBD1D6;">
                            <div style="font-size: 14px;color: #000;">
                                <span class="modules-panel-number" style="padding-right: 5px;color: #C10B14;">{{autoRebalanceOrderData.errorCount | number}}</span>
                                <span>Orders with errors</span>
                            </div>
                            <img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg" (click)="showAutoRebalError()" >
                        </div>
                    }
                    @if (autoRebalanceOrderData.approvedCount > 0) {
                        <div class="module-flex-row-with-space" style="padding: 10px 0;border-bottom: 1px solid #CBD1D6;">
                            <div style="font-size: 14px;color: #000;">
                                <span class="modules-panel-number" style="padding-right: 5px;">{{autoRebalanceOrderData.approvedCount | number}}</span>
                                <span>Pending orders</span>
                            </div>
                            <img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg" (click)="showAutoRebalPending()" >
                        </div>
                    }
                    @if (autoRebalanceOrderData.submitedCount > 0) {
                        <div class="module-flex-row-with-space" style="padding: 10px 0;">
                            <div style="font-size: 14px;color: #000;">
                                <span class="modules-panel-number" style="padding-right: 5px;">{{autoRebalanceOrderData.submitedCount | number}}</span>
                                <span>Submitted orders</span>
                            </div>
                            <img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg" (click)="showAutoRebal()" >
                        </div>
                    }
                    @if (!autoRebalanceOrderData.totalCount && currentDate === nextDate) {
                        <div style="padding: 10px 0;">
                            <span style="color: #000;line-height: 20px;">Automated rebalance orders are being processed. Please try again later.</span>
                        </div>
                    }
                </ng-template>
            }

        </div>
        </p-card>
    }
    @if (customizableMode) {
        <div style="padding: 25px 10px;">
            <div style="display: flex;flex-direction: row;">
                <div [style.width.%]="singleWidth ? 50 : 33.33" style="padding-right: 30px;">
                    <div class="skeleton-styles-rectangle" style="width: 60%;"></div>
                    <div class="skeleton-styles-rectangle" style="width: 100%;margin-top: 15px;"></div>
                    <div style="display: flex;flex-direction: row;justify-content: space-between;margin-top: 15px;">
                        <div class="skeleton-styles-rectangle" style="width: 75%;"></div>
                        <div class="skeleton-styles-circle" style="margin-left: 10px"></div>
                    </div>
                    <div style="display: flex;flex-direction: row;justify-content: space-between;margin-top: 15px;">
                        <div class="skeleton-styles-rectangle" style="width: 65%;"></div>
                        <div class="skeleton-styles-circle" style="margin-left: 10px"></div>
                    </div>
                    <div style="display: flex;flex-direction: row;justify-content: space-between;margin-top: 15px;">
                        <div class="skeleton-styles-rectangle" style="width: 60%;"></div>
                        <div class="skeleton-styles-circle" style="margin-left: 10px"></div>
                    </div>
                </div>

                @if (!singleWidth) {
                    <div [style.width.%]="singleWidth ? 50 : 33.33" style="padding-right: 30px;">
                        <div style="height: 24px;"></div>
                        <div class="skeleton-styles-rectangle" style="width: 100%;margin-top: 15px;"></div>
                        <div style="display: flex;flex-direction: row;justify-content: space-between;margin-top: 15px;">
                            <div class="skeleton-styles-rectangle" style="width: 65%;"></div>
                            <div class="skeleton-styles-circle" style="margin-left: 10px"></div>
                        </div>
                        <div style="display: flex;flex-direction: row;justify-content: space-between;margin-top: 15px;">
                            <div class="skeleton-styles-rectangle" style="width: 70%;"></div>
                            <div class="skeleton-styles-circle" style="margin-left: 10px"></div>
                        </div>
                    </div>
                }

                <div [style.width.%]="singleWidth ? 50 : 33.33">
                    <div style="height: 24px;"></div>
                    <div class="skeleton-styles-rectangle" style="width: 100%;margin-top: 15px;"></div>
                    <div style="display: flex;flex-direction: row;justify-content: space-between;margin-top: 15px;">
                        <div class="skeleton-styles-rectangle" style="width: 75%;"></div>
                        <div class="skeleton-styles-circle" style="margin-left: 10px"></div>
                    </div>
                    <div style="display: flex;flex-direction: row;justify-content: space-between;margin-top: 15px;">
                        <div class="skeleton-styles-rectangle" style="width: 70%;"></div>
                        <div class="skeleton-styles-circle" style="margin-left: 10px"></div>
                    </div>
                </div>

            </div>
        </div>

    }
